<template>
  <div class="d-flex">
    <div class="position-absolute ml-2 mt-n10px h-15px font-12 bg-white z-999 px-1">Filtro de Categorias</div>

    <v-autocomplete
      :items="listaDeFornecedores"
      item-text="descricao_categoria"
      item-value="id_categoria"
      multiple
      outlined
      hide-details
      :placeholder="primeirCategoriaSelecionada ? '' : 'Nenhum selecionado'"
    >
      <template v-slot:prepend-item>
        <v-list-item class="sys-item-prepended-list px-3 py-2" @click="selecionarTodos()">
          <template v-if="todosSelecionados">
            <v-icon color="primary">mdi-checkbox-marked</v-icon>
            <span class="subtitle-1 ml-3">Desmarcar todas as categorias</span>
          </template>
          <template v-else>
            <v-icon v-if="!categoriasSelecionados.length">mdi-checkbox-blank-outline</v-icon>
            <v-icon v-else color="primary">mdi-minus-box</v-icon>
            <span class="subtitle-1 ml-3">Selecionar todas as categorias</span>
          </template>
        </v-list-item>

        <v-divider />
      </template>

      <template v-slot:item="{item}">
        <v-list-item class="item-list px-3" @click="addOuRemoveItem(item)">
          <v-list-item-icon>
            <v-icon v-if="categoriaSelecionada(item)" color="primary">
              mdi-checkbox-marked
            </v-icon>
            <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="ml-n6">
            <v-list-item-title>{{item.id_categoria}} - {{item.descricao_categoria}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <template v-slot:prepend-inner v-if="categoriasSelecionados.length > 0">
        <v-chip dense class="ma-0 mt-n1">{{ primeirCategoriaSelecionada }}</v-chip>
      </template>

      <template v-slot:append>
        <template v-if="categoriasSelecionados.length > 1">
          <v-chip small outlined color="#666666" style="height: 20px">
            + {{ `${categoriasSelecionados.length} selecionados`}}
          </v-chip>
        </template>
        <template v-else>
          <v-icon>mdi-filter</v-icon>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import mixin from '../MixinDRP'

export default {
  name: "filtroDeCategoria",
  model: {
    prop: 'categoriasSelecionados',
    event: 'change-categorias'
  },
  props: {
    categoriasSelecionados: {
      type: Array,
      required: true
    },
    itensFull: {
      type: Array,
      required: false
    }
  },
  mixins: [mixin],
  computed: {
    listaDeFornecedores () {
      return this.itensFull;
    },
    todosSelecionados () {
      return this.categoriasSelecionados.length > 0 && this.categoriasSelecionados.length === this.listaDeFornecedores.length
    },
    primeirCategoriaSelecionada () {
      if (this.categoriasSelecionados.length === 0) return 0;

      return this.categoriasSelecionados[0].descricao_categoria.trim();
    }
  },
  methods: {
    categoriaSelecionada (item) {
      const selecionado = this.categoriasSelecionados.filter(forn => forn.id_categoria == item.id_categoria)

      return selecionado.length > 0
    },
    selecionarFornecedores (ev) {
      this.$emit('change-categorias', ev)
    },
    selecionarTodos () {
      if (this.todosSelecionados) {
        this.selecionarFornecedores([])
      } else {
        this.selecionarFornecedores(this.listaDeFornecedores)
      }
    },
    addOuRemoveItem (item) {
      let novosSelecionados

      if (this.categoriaSelecionada(item)) {
        novosSelecionados = this.categoriasSelecionados.filter(categoria => categoria.id_categoria != item.id_categoria)
      } else {
        novosSelecionados = this.categoriasSelecionados.concat(item)
      }

      this.selecionarFornecedores(novosSelecionados)
    }
  }
}
</script>

<style scoped>
.txt-primeiro-selecionado {
  font-size: 13px;
  white-space: nowrap;
  width: 13em;
}
</style>
